import {
    DeliveryApiImage,
    TemplatePreviewSection
} from "@/templates/software/confluence/templates/confluence-templates-page/src/sections/template-preview-section";

export interface UniformTemplatePreviewProps {
    templatePreview: DeliveryApiImage;
}

const UniformTemplatePreview: React.FC<UniformTemplatePreviewProps> = ({
    templatePreview
}: UniformTemplatePreviewProps) => {
    return (
        <TemplatePreviewSection
            templatePreview={templatePreview}
            hideBackground={true}
            omitPadding={true}
            fullWidth={true}
        />
    );
};

export default UniformTemplatePreview;
